<template>
  <div class="main-layout min-h-screen flex flex-col">
    <Navbar />

    <slot class="flex-grow" />
  </div>
</template>
